module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/insights-uppingthestakes.json
// module id = 1421
// module chunks = 28773743132716